/* eslint-disable camelcase */
import { useQuery } from '@tanstack/react-query';
import { MERCHANT_PAYMENT } from 'Utils/queries';
import { getPaymentApplication } from 'Services/Applications/Application';
import { MerchantPaymentResponse, PaymentType } from 'Src/models/Applications/Payment';
import { mapToAurora } from 'Utils/mapToAurora';

export default function useMerchantPaymentQuery({
  enabled = true,
  refetchOnMount = false,
} = {}) {
  return useQuery({
    enabled,
    queryFn: async () => {
      const resp = await getPaymentApplication() as MerchantPaymentResponse;
      const data = mapToAurora(resp);

      const isCashInstallments = data.payment?.paymentType === PaymentType.CashInstallments;
      const isKueskipay = data.payment?.paymentType === PaymentType.Kueskipay;
      const isInstoreConsumer = data.payment?.paymentType === PaymentType.InstoreConsumer;

      const payment = data.payment ? {
        ...data.payment,
        isCashInstallments,
        isInstoreConsumer,
        isKueskipay,
        merchantName: data.payment.merchantName,
      } : null;

      return {
        ...data,
        payment,
      };
    },
    queryKey: [MERCHANT_PAYMENT],
    refetchOnMount,
  });
}
